import { library } from '@fortawesome/fontawesome-svg-core'
import { faPaperPlane, faInfoCircle, faDownload, faGear, faRankingStar, faArrowTrendUp, faArrowTrendDown } from '@fortawesome/free-solid-svg-icons'

library.add(faPaperPlane, faInfoCircle, faDownload, faGear, faRankingStar, faArrowTrendUp, faArrowTrendDown)
